import request from '../request'

export const CRM = {
  // ============================================================
  // 客户管理（Admin 后台接口，baseType: 'api'）
  // ============================================================

  /** 查询客户列表 */
  getCustomerList (params, options = {}) {
    return request({
      url: '/crm/customer/list',
      method: 'GET',
      params,
      requiresAuth: true,
      baseType: 'api',
      ...options
    })
  },

  /** 查询客户详情 */
  getCustomerDetail (userId) {
    return request({
      url: `/crm/customer/detail/${userId}`,
      method: 'GET',
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 新增客户 */
  addCustomer (data) {
    return request({
      url: '/crm/customer',
      method: 'POST',
      data,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 修改客户信息 */
  updateCustomer (userId, data) {
    return request({
      url: `/crm/customer/update/${userId}`,
      method: 'PUT',
      data,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 查询客户跟进记录 */
  getFollowRecords (userId, params) {
    return request({
      url: `/crm/customer/follow/records/${userId}`,
      method: 'GET',
      params,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  // ============================================================
  // 订单管理（Admin 后台接口，baseType: 'api'）
  // ============================================================

  /** 提交客户订单 */
  submitOrder (userId, data) {
    return request({
      url: `/crm/order/submit/${userId}`,
      method: 'POST',
      data,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 撤回客户订单 */
  withdrawOrder (userId) {
    return request({
      url: `/customer/${userId}/order/withdraw`,
      method: 'PUT',
      requiresAuth: true
    })
  },

  /** 审核客户订单（管理员） */
  auditOrder (userId, data) {
    return request({
      url: `/customer/${userId}/order/audit`,
      method: 'PUT',
      data,
      requiresAuth: true
    })
  },

  /** 申请退费 */
  applyRefund (userId, reason) {
    return request({
      url: `/customer/${userId}/refund`,
      method: 'POST',
      data: { reason },
      requiresAuth: true
    })
  },

  // ============================================================
  // 联系人管理（Admin 后台接口，baseType: 'api'）
  // ============================================================

  /** 查询客户联系人列表 */
  getContactList (userId) {
    return request({
      url: `/crm/contact/list/${userId}`,
      method: 'GET',
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 查询联系人详情 */
  getContactDetail (contactId) {
    return request({
      url: `/crm/contact/detail/${contactId}`,
      method: 'GET',
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 新增联系人 */
  addContact (data) {
    return request({
      url: '/crm/contact',
      method: 'POST',
      data,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 更新联系人 */
  updateContact (data) {
    return request({
      url: '/crm/contact',
      method: 'PUT',
      data,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 删除联系人 */
  deleteContact (ids, userId) {
    return request({
      url: `/crm/contact?user_id=${userId}`,
      method: 'DELETE',
      data: { ids },
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 批量保存联系人 */
  saveContactsBatch (data) {
    return request({
      url: '/crm/contact/batch',
      method: 'POST',
      data,
      requiresAuth: true,
      baseType: 'api'
    })
  },

  // ============================================================
  // 跟进管理（H5 后台接口）
  // ============================================================

  /** 查询今日跟进 */
  getTodayFollowList (params) {
    return request({
      url: '/follow/today',
      method: 'GET',
      params,
      requiresAuth: true
    })
  },

  /** 添加跟进记录 */
  addFollowRecord (data) {
    return request({
      url: '/follow/record',
      method: 'POST',
      data,
      requiresAuth: true
    })
  },

  /** 退回公海 */
  returnToPool (userId, data) {
    return request({
      url: `/follow/${userId}/return-pool`,
      method: 'POST',
      data,
      requiresAuth: true
    })
  },

  // ============================================================
  // 推广员功能（H5 后台接口）
  // ============================================================

  /** 查询待分配客户列表 */
  getUnassignedList (params, options = {}) {
    return request({
      url: '/follow/unassigned',
      method: 'GET',
      params,
      requiresAuth: true,
      ...options
    })
  },

  /** 查询跟进情况列表 */
  getFollowingList (params, options = {}) {
    return request({
      url: '/follow/following',
      method: 'GET',
      params,
      requiresAuth: true,
      ...options
    })
  },

  /** 分配客服 */
  assignToFollower (userId, data) {
    return request({
      url: `/follow/${userId}/assign`,
      method: 'POST',
      data,
      requiresAuth: true
    })
  },

  // ============================================================
  // 回收站（Admin 后台接口，baseType: 'api'）
  // ============================================================

  /** 查询回收站列表（使用客户列表接口 + status=0） */
  getRecycleList (params, options = {}) {
    return request({
      url: '/crm/customer/list',
      method: 'GET',
      params: { ...params, status: 0 },
      requiresAuth: true,
      baseType: 'api',
      ...options
    })
  },

  /** 恢复回收站客户 */
  restoreCustomers (ids) {
    return request({
      url: '/crm/customer/recover',
      method: 'PUT',
      data: { ids },
      requiresAuth: true,
      baseType: 'api'
    })
  },

  /** 彻底删除回收站客户 */
  deleteCustomersPermanent (ids) {
    return request({
      url: '/crm/customer',
      method: 'DELETE',
      data: { ids },
      requiresAuth: true,
      baseType: 'api'
    })
  },

  // ============================================================
  // 首页与动态（H5 后台接口）
  // ============================================================

  /** 查询首页统计 */
  getHomeStats (params, options = {}) {
    return request({
      url: '/home/stats',
      method: 'GET',
      params,
      requiresAuth: true,
      ...options
    })
  },

  /** 查询跟进动态列表 */
  getActivityList (params, options = {}) {
    return request({
      url: '/home/activities',
      method: 'GET',
      params,
      requiresAuth: true,
      ...options
    })
  },

  // ============================================================
  // 消息中心（H5 后台接口）
  // ============================================================

  /** 查询消息列表 */
  getMessageList (params, options = {}) {
    return request({
      url: '/message/list',
      method: 'GET',
      params,
      requiresAuth: true,
      ...options
    })
  },

  /** 标记消息已读 */
  markMessageRead (messageId) {
    return request({
      url: `/message/${messageId}/read`,
      method: 'PUT',
      requiresAuth: true
    })
  },

  /** 标记全部消息已读 */
  markAllMessageRead () {
    return request({
      url: '/message/read-all',
      method: 'PUT',
      requiresAuth: true
    })
  },

  /** 查询未读消息数量 */
  getUnreadCount () {
    return request({
      url: '/message/unread-count',
      method: 'GET',
      requiresAuth: true
    })
  },

  // ============================================================
  // 通知公告（H5 后台接口）
  // ============================================================

  /** 查询通知列表 */
  getNoticeList (params) {
    return request({
      url: '/notice/list',
      method: 'GET',
      params,
      requiresAuth: true
    })
  },

  /** 查询首页通知 */
  getHomeNotices () {
    return request({
      url: '/notice/list',
      method: 'GET',
      params: { pageSize: 5, pageNum: 1 },
      requiresAuth: true
    })
  },

  /** 查询弹窗公告（公开） */
  getPopupAnnouncement () {
    return request({
      url: '/notice/popup_announcement',
      method: 'GET'
    })
  },

  /** 查询通知详情 */
  getNoticeDetail (id) {
    return request({
      url: `/notice/${id}`,
      method: 'GET',
      requiresAuth: true
    })
  },

  /** 标记通知已读 */
  readNotice (noticeId) {
    return request({
      url: `/notice/${noticeId}/set-read`,
      method: 'PUT',
      requiresAuth: true
    })
  },

  /** 标记通知未读 */
  markNoticeUnread (noticeId) {
    return request({
      url: `/notice/${noticeId}/set-unread`,
      method: 'PUT',
      requiresAuth: true
    })
  },

  // ============================================================
  // 字典数据（H5 后台接口，公开/需登录）
  // ============================================================

  /** 查询品牌列表 */
  getBrandList (params) {
    return request({
      url: '/dicts/brands',
      method: 'GET',
      params,
      requiresAuth: true
    })
  },

  /** 查询门店列表 */
  getStoreList (brandId) {
    return request({
      url: '/dicts/stores',
      method: 'GET',
      params: { brand_id: brandId },
      requiresAuth: true
    })
  },

  /** 查询宴会类型列表 */
  getBanquetTypeList (params) {
    return request({
      url: '/dicts/banquet-types',
      method: 'GET',
      params,
      requiresAuth: true
    })
  },

  /** 查询渠道来源列表 */
  getChannelList () {
    return request({
      url: '/dicts/channels',
      method: 'GET',
      requiresAuth: true
    })
  },

  /** 查询跟进标识字典 */
  getFollowFlagList () {
    return request({
      url: '/dicts/options/crm_follow_flag',
      method: 'GET',
      requiresAuth: true
    })
  },

  /** 查询城市区域字典 */
  getCityList () {
    return request({
      url: '/dicts/options/city_region',
      method: 'GET',
      requiresAuth: true
    })
  },

  /** 查询跟进人列表 */
  getFollowerOptions () {
    return request({
      url: '/system/follow-options',
      method: 'GET',
      requiresAuth: true,
      baseType: 'api'
    })
  },

  // ============================================================
  // 多媒体（公开接口）
  // ============================================================

  /** 获取轮播图数据 */
  getSwiperData () {
    return request({
      url: '/media/swiper/home_swiper',
      method: 'GET'
    })
  },

  /** 获取视频数据 */
  getVideosData () {
    return request({
      url: '/media/video/home_video',
      method: 'GET'
    })
  }
}
